import React from "react";
import PropTypes from "prop-types";
import classes from "./feeCard.module.scss";

const FeeCard = ({ fee, ...rest }) => {
  return (
    <div className={classes.feeCard} {...rest}>
      <div className={classes.content}>
        <div className={classes.top}>
          <div className={classes.title}>{fee.content}</div>
          <div className={classes.via}>{fee.paid_via}</div>
        </div>
        <div className={classes.date}>
          {new Date(fee.payment_time * 1000).toLocaleString("en-GB")}
        </div>
      </div>
    </div>
  );
};

FeeCard.propTypes = {
  fee: PropTypes.shape({
    payment_time: PropTypes.number,
    content: PropTypes.string,
    payment_id: PropTypes.number,
    paid_via: PropTypes.string,
  }).isRequired,
};

export default FeeCard;
